import React from "react";
import values from "../../values";
import Context from "../../context";
import Components from "./Components";

import {
  BreadCrumb,
  Pagination,
  TableHeader,
  TableLoading,
  ResponsiveView, SubTabs,
  CustomButton2,
} from "../../components";

import "./index.sass";
import Cookies from "js-cookie";
import constants from "../../values/constants";
import PayModal from "./Components/PayAllServices/components/PayModal";
import { useTranslation } from "react-i18next";
import {DRIVER_TABS, FILTER_USER_BY_FAVORIT_CITIES} from "../../values/subTabs";
import {ITopMenuItem} from "../../types/common.interface";
import CustomCheckbox from "../../components/CustomCheckbox";

interface iItem {
  value: string;
  pathname: string;
  name?: string;
}

type Props = {
  resultDriver: any;
  role: "ADMIN" | "SUPER_AGENT_SCHOOL" | "COMPANY";
};

const DriverScreen = (props: Props) => {

  // # =================================================================================================================
  // # --------------------------------------------- Start Validate Values ---------------------------------------------

  const { data, status } = props.resultDriver;
  const {
    requestDriver,
    setRequestDriver,
    includePreviousYear,
    setIncludePreviousYear,
    selectedDriverIds,
    setSelectedDriverIds,
    setSelectedDriver,
    setShowModal,
  } = React.useContext(Context.DriverScreen);

  const writePermission = Cookies.get(constants.USER.WRITE_PERMISSION)?.toString();

  const { t } = useTranslation();
  let tabs: Array<iItem> = DRIVER_TABS;

  tabs = tabs.map((item) => ({ ...item, value: t(item.value) }));

  const [selectedCity, setSelectedCity] = React.useState<ITopMenuItem>(FILTER_USER_BY_FAVORIT_CITIES[0]);
  const [isShowApproe, setIsShowApprove] = React.useState<boolean>(false);
  const [isShowNotApprove, setIsShowNotApprove] = React.useState<boolean>(false);

  function onCityClick(tab: ITopMenuItem): void {
    setSelectedCity(tab);
    setRequestDriver!({
      ...requestDriver,
      filters: {
        ...requestDriver?.filters,
        city: tab,
      },
    });
  }

  function onClickNotApprovedDrivers(): void {
    setIsShowNotApprove(!isShowNotApprove)
    setIsShowApprove(false);
    setRequestDriver!({
      ...requestDriver,
      filters: {
        ...requestDriver?.filters,
        approved: !isShowNotApprove ? false : undefined,
      },
    });
  }

  // ? Listing last year's drivers so they can be carried over. Leaving the mode clears whatever was ticked.
  function onClickPreviousYearDrivers(): void {
    setIncludePreviousYear!(!includePreviousYear);
    setSelectedDriverIds!([]);
  }

  // ? The bulk transfer shares its modal with the per-row one, which tells the two apart by selectedDriver.
  function onTransferSelected(): void {
    setSelectedDriver!(undefined);
    setShowModal!("TRANSFER_ACADEMIC_YEAR");
  }

  function onClickApprovedDrivers(): void {
    setIsShowApprove(!isShowApproe);
    setIsShowNotApprove(false);
    setRequestDriver!({
      ...requestDriver,
      filters: {
        ...requestDriver?.filters,
        approved: !isShowApproe ? true : undefined,
      },
    });
  }

  return (
    <ResponsiveView.Container id="driver-screen-container">
      <ResponsiveView.Row>
        <SubTabs tabs={FILTER_USER_BY_FAVORIT_CITIES} onClick={onCityClick} selected={selectedCity as ITopMenuItem} />
      </ResponsiveView.Row>
      <ResponsiveView.Row className="table-options-wrapper">
        <ResponsiveView.Column extraLarge={4} large={5} medium={5} className="bread-crumb-wrapper">
          <BreadCrumb />
          <label id="approve-checkbox-container">
            <input type="checkbox" onChange={onClickNotApprovedDrivers} checked={isShowNotApprove}/>
            <p>رانندگان تایید نشده</p>
          </label>
          <label id="approve-checkbox-container">
            <input type="checkbox" onChange={onClickApprovedDrivers} checked={isShowApproe}/>
            <p>رانندگان تایید شده</p>
          </label>
          <label id="approve-checkbox-container">
            <input type="checkbox" onChange={onClickPreviousYearDrivers} checked={includePreviousYear}/>
            <p>{t("showPreviousYearDrivers")}</p>
          </label>
        </ResponsiveView.Column>
        <ResponsiveView.Column extraLarge={4} large={5} medium={7} className="search-and-filter-wrapper">
          {writePermission === "true" && (
            <Components.Create role={props.role} />
          )}
          {writePermission === "true" && (selectedDriverIds?.length ?? 0) > 0 && (
            <CustomButton2
              title={`${t("transferToCurrentYear")} (${selectedDriverIds?.length})`}
              onClick={onTransferSelected}
            />
          )}
          <Components.Filter />
          <Components.Search />
        </ResponsiveView.Column>
      </ResponsiveView.Row>
      <div className="table-content-wrapper">
        <table>
          <TableHeader
            headers={(includePreviousYear
              ? ["select", ...values.tableHeaders.DRIVER_HEADERS]
              : values.tableHeaders.DRIVER_HEADERS
            ).map((item) => t(item))}
          />
          {status === "loading" ? (
            <TableLoading />
          ) : (
            <Components.Body data={data?.result?.docs} />
          )}
        </table>
      </div>
      {status === "success" &&
        data?.result?.totalDocs >
          values.constants.PANEL_TABLE_DEFAULT_LIMIT && (
          <div className="pagination">
            <Pagination
              page={requestDriver?.page}
              totalPages={data?.result?.totalPages}
              onPaginate={(page: number) =>
                setRequestDriver!({ ...requestDriver, page })
              }
            />
          </div>
        )}
      {writePermission === "true" && (
        <>
          <Components.Approve />
          <Components.Update role={props.role} />
        </>
      )}
      <Components.ShowCompanyInformation />
      <Components.ShowDriverInformation  />
      <Components.ClosedFactorModal      />
      <Components.ApproveDocuments       />
      <Components.TransferAcademicYear   />
      <Components.RemoveIsArchive        />
      <Components.PayAllServices         />
      <Components.ShowAllService         />
      <Components.ShowBlockInfo          />
      <Components.Favorite               />
      <Components.Deposit                />
      <Components.UnBlock                />
      <Components.Block                  />
      <PayModal />
    </ResponsiveView.Container>
  );

  // ? ------------------------------------------------ End Return View ------------------------------------------------
  // ? =================================================================================================================
};

export default DriverScreen;
